
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiDieselGeneratorStep as ObiDieselGeneratorStepElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-diesel-generator-step.js';
 
 
 

 
 export const ObiDieselGeneratorStep = createComponent({
   react: React,
   tagName: 'obi-diesel-generator-step',
   elementClass: ObiDieselGeneratorStepElement,
   events: {
     
   }
  });
 
 